<template>
  <AppTooltip v-if="signatoriesLists.length !== 0" data-locator="bulk-signatories-list-tooltip">
    <template v-slot:activator="{ props }">
      <ul class="list-raw" v-bind="props">
        <li v-for="list in signatoriesLists" :key="list.typeLabel">
          <span v-t="{
            path: `project.signing-checklist.list.SigningChecklistMultiEnvelopeSignatoriesList.signatories${list.typeLabel}Total`,
            plural: list.items.length,
              }"
          />
        </li>
      </ul>
    </template>
    <div v-for="list in signatoriesLists" :key="list.typeLabel">
      <span class="text--small text--bold">
        {{ $t(`project.signing-checklist.list.SigningChecklistMultiEnvelopeSignatoriesList.signatories${list.typeLabel}Title`) }}
      </span>
      <ul class="ml-6">
        <li
          v-for="signer in list.items"
          :key="`signer-${signer.id}`"
          class="text--small"
        >
          {{ signer.fullName }}
        </li>
      </ul>
    </div>
  </AppTooltip>
</template>

<script>
import AppTooltip from '@/common/AppTooltip.vue'
import { flatten } from '@/common/utils/flatArray'

export default {
  name: 'SigningChecklistMultiEnvelopeSignatoriesList',
  components: { AppTooltip },
  props: {
    signatories: {
      type: Array,
      required: true,
    },
  },
  computed: {
    flatSignatories () {
      return flatten([], this.signatories)
    },
    signatoriesCommonList () {
      return this.flatSignatories.filter(signature => signature.signatureType === 'single')
    },
    signatoriesLists () {
      const lists = []

      if (this.signatoriesCommonList.length !== 0) { lists.push({ typeLabel: 'Common', items: this.signatoriesCommonList }) }
      if (this.signatoriesUniqueList.length !== 0) { lists.push({ typeLabel: 'Unique', items: this.signatoriesUniqueList }) }

      return lists
    },
    signatoriesUniqueList () {
      const filteredSignatories = this.flatSignatories.find(signature => signature.signatureType === 'multiple')
      return filteredSignatories?.signers || []
    },
  },
}
</script>
